<template>
  <div class="collect-reviews-section">
    <div class="columns is-flex flex-align-centre header-section">
      <div class="column header-text">
        Collect Reviews
      </div>
      <div class="column has-text-right">
        <a
          class="about-feature" target="_blank"
          href="https://intercom.help/hellopeter/en/articles/4228174-review-invites"
        >
          <img src="/static/img/dummy-help.png"/>
          <span class="abt_section">About this feature</span>
        </a>
      </div>
    </div>
    <!-- Share Invite Section Begins -->
    <div class="send-invite-section">
      <div class="columns">
        <div class="column heading-text">Send Quick Review Invite</div>
        <div class="column padding-top-0 heading-content">
          We automatically deliver the in-mail template. If you add a mobile number, your customer will receive an SMS
          invite in addition to the email invite.
        </div>
        <div class="column margin-0 is-block padding-top-0 form-section">
          <div class="column padding-left-0 padding-top-0">
            <label class="label-text" for="First Name">First Name</label><br>
            <input class="width-100" type="text" placeholder="First Name" v-model="quickReply.name">
            <span class="error" v-if="errors.quickReply.name">*{{errors.quickReply.name}}</span>
          </div>
          <div class="column padding-left-0 padding-top-0">
            <label class="label-text" for="Email Address">Email Address</label><br>
            <input class="width-100" type="text" placeholder="Email Address" v-model="quickReply.email">
            <span class="error" v-if="errors.quickReply.email">*{{errors.quickReply.email}}</span>
          </div>
          <div class="column padding-left-0 padding-top-0">
            <label class="label-text" for="Mobile">Mobile Number (optional)</label><br>
            <input class="width-100" type="text" placeholder="000 000 0000" v-model="quickReply.mobile">
            <span class="error" v-if="errors.quickReply.mobile">*{{errors.quickReply.mobile}}</span>
          </div>
          <div class="column has-text-centered padding-left-0">
            <button
              class="button is-button-dark-blue is-uppercase"
              :class="[{'is-loading': loader.isSending}, {'disabled': loader.isSending}]"
              @click="handleQuickInvite"
            >
              Send Invite
            </button>
          </div>
        </div>
      </div>
    </div> <!-- Share Invite Section Ends -->
    <div class="columns share-link-section">
      <div class="column padding-bottom-0"><span class="header-text">Your Review Share Link</span></div>
      <!-- Landing Page Share Begins -->
      <div class="column is-block padding-top-0 padding-bottom-0">
        <div class="column is-flex flex-align-centre padding-left-0">
          <img src="/static/img/review-invites/whatsapp-review-invite-link.png" alt="share" height="20" width="20">&nbsp;&nbsp;
          <span class="share-icon-text">Whatsapp</span>
        </div>
        <div class="column padding-left-0 padding-top-0 share-icon-description">Leave a review on your dedicated WhatsApp channel</div>
        <div class="column is-flex padding-left-0 padding-top-0 width-50">
          <div class="column padding-left-0 is-narrow has-text-centered cursor" @click="shareViaWebShare('whatsAppLink')">
            <img src="/static/img/review-invites/ic-share.png" alt="share" height="30" width="30"><br>
            <span class="share-text-small">Share</span>
          </div>
          <div class="column is-narrow has-text-centered cursor" @click="copyLink('whatsAppLink')">
            <img src="/static/img/review-invites/ic-copy.png" alt="copy" height="30" width="30"><br>
            <span class="share-text-small">Copy Link</span>
          </div>
        </div>
      </div> <!-- Landing Page Share Ends -->
      <!-- Landing Page Share Begins -->
      <div class="column is-block padding-top-0">
        <div class="column is-flex flex-align-centre padding-left-0 padding-top-0">
          <img src="/static/img/review-invites/review-invite-link.svg" alt="share" height="20" width="20">&nbsp;&nbsp;
          <span class="share-icon-text">Landing Page</span>
        </div>
        <div class="column padding-left-0 padding-top-0 share-icon-description">Leave a review on your dedicated Hellopeter landing page</div>
        <div class="column is-flex padding-left-0 padding-top-0 width-50">
          <div class="column padding-left-0 is-narrow has-text-centered cursor" @click="shareViaWebShare('portalHomepage')">
            <img src="/static/img/review-invites/ic-share.png" alt="share" height="30" width="30"><br>
            <span class="share-text-small">Share</span>
          </div>
          <div class="column is-narrow has-text-centered cursor" @click="copyLink('portalHomepage')">
            <img src="/static/img/review-invites/ic-copy.png" alt="copy" height="30" width="30"><br>
            <span class="share-text-small">Copy Link</span>
          </div>
        </div>
      </div> <!-- Landing Page Share Begins -->
    </div>
  </div>
</template>

<script>
  /* eslint-disable indent,no-new,no-undef,no-unused-expressions, no-useless-escape, valid-jsdoc */
  import Misc from '@/mixins/misc.js'
  import _ from 'lodash'
  import axios from 'axios'
  export default {
    name: 'CollectReviewsMobile',
    mixins: [Misc],
    data () {
      return {
        loader: {isSending: false},
        business: {
          slug: localStorage.getItem('org_slug'),
          name: localStorage.getItem('org_name'),
          consumerUrl: process.env.HP_APP_URL
        },
        quickReply: {
          name: null,
          email: null,
          mobile: null
        },
        errors: {
          quickReply: {
            name: null,
            email: null,
            mobile: null
          }
        }
      }
    },
    computed: {
      /**
       * Portal Homepage URL
       * @return {string}
       */
      portalHomepageUrl () {
        const source = 'UE9SVEFMX0NPUFlfTElOS19JTlZJVEU%3D'
        return `${this.business.consumerUrl}/write-a-review/${this.business.slug}?source=${source}&r=true`
      },
      /**
       * Whatsapp review invite link
       * @return {string}
       */
      whatsAppInviteURL () {
        return `https://wa.me/27212066516?text=${encodeURIComponent('To start writing a review about ')}${encodeURIComponent(this.business.name)}${encodeURIComponent(' TAP THE SEND ARROW')}`
      },
      /**
       * Chwck whether device support WebShareApi
       * @return {boolean}
       */
      webShareApiSupported () {
        return navigator.share || false
      }
    },
    methods: {
      /**
       * Copy link for relative URLs
       * @return {string}
       */
      copyLink (linkType = 'portalHomepage') {
        let url = linkType === 'portalHomepage' ? this.portalHomepageUrl : this.whatsAppInviteURL
        this.$copyText(url)
        .then(() => {
          this.displaySuccessMsg(`Successfully copied '${url}' to your clipboard`, `Successfully copied '${this.portalHomepageUrl}' to your clipboard`)
        })
      },
      /**
       * Open share dialog for the device natively
       * @return {void}
       */
      shareViaWebShare (linkType = 'portalHomepage') {
        let url = linkType === 'portalHomepage' ? this.portalHomepageUrl : this.whatsAppInviteURL
        if (this.webShareApiSupported) {
          navigator.share({
            title: `${this.business.name}`,
            text: `${this.business.name}`,
            url: url
          })
        } else {
          flash(`Your device don't support sharing feature.`, 'is-info')
        }
      },
      /**
       * Handle quick invite
       * @returns {void}
       **/
      handleQuickInvite () {
        const regex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        _.forIn(this.errors.quickReply, (value, key) => {
          if (!this.quickReply[key] && key !== 'mobile') {
            this.errors.quickReply[key] = `${key[0].toUpperCase()}${key.slice(1)} required`
          } else {
            this.errors.quickReply[key] = null
            if (key === 'email' && !regex.test(String(this.quickReply[key]).toLowerCase())) {
              this.errors.quickReply[key] = `${key[0].toUpperCase()}${key.slice(1)} is not valid`
            }
          }
        })
        /** If its passed all validations */
        if (_.values(this.errors.quickReply).every(_.isEmpty)) {
          let arr = []
          this.loader.isSending = true
          arr.push({
            email: this.quickReply.email,
            mobile: this.quickReply.mobile,
            firstname: this.quickReply.name,
            sendInMailAsDefault: true
          })
          axios.post(`marketing/${this.business.slug}/send-business-review-invitations`, {
            emailList: arr
          })
          .then((data) => {
            this.loader.isSending = false
            Object.keys(this.quickReply).forEach((key) => { this.quickReply[key] = null })
            this.displaySuccessMsg(`Invite sent successfully.`, `Mail sent successfully to invite user.`)
          })
          .catch((error) => {
            this.displayErrMsg(error, 'Failed in sending mail', 'Oops, something went wrong. Please try reloading or contact our administrator')
          })
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import '@/assets/scss/variables.scss';

  .collect-reviews-section {
    padding: 0 12px;

    .header-section {
      margin: 0;
      border-bottom: solid 1px rgba(112, 112, 112, 0.12);

      .header-text {
        color: $text-color;
        font-size: 12px;
        font-weight: bold;
      }
    }
    .send-invite-section {
      padding-bottom: 20px;
      border-bottom: solid 1px rgba(88, 89, 91, 0.32);

      .heading-text {
        color: $dark-blue-color;
        font-size: 14px;
        font-weight: bold;
      }
      .heading-content {
        color: $text-color;
        font-size: 12px;
      }
      .form-section {
        .label-text {
          color: $text-color;
          font-size: 12px;
          font-weight: bold;
        }
        input {
          height: 35px;
          border: solid 1px #dbdbdb;
          padding: 0 12px;
        }
      }
    }
    .share-link-section {
      .header-text {
        color: $dark-blue-color;
        font-size: 14px;
        font-weight: bold;
      }
      .share-icon-text {
        color: $text-color;
        font-size: 12px;
        font-weight: bold;
      }
      .share-icon-description {
        color: $text-color;
        font-size: 12px;
      }
      .share-text-small {
        color: $text-color;
        font-size: 10px;
      }
    }
  }

  /* Helper css Begins */
  .cursor {
    cursor: pointer;
  }
  .error {
    color: red;
    font-size: 12px;
  }
  /* Helper css ends */
</style>

<!-- Global CSS Begins -->
<style>
  div#sideBar .is-padding-top-0 {
    padding-top: 5px;
  }
</style>
<!-- Global CSS Ends -->



// WEBPACK FOOTER //
// src/pages/collect-reviews/CollectReviewsMobile.vue